import { Row, Rows } from 'common/types/scalarSpreadsheet';
import { ValueWithLinkViewer } from 'components';
import {
  FUND_INVESTMENTS_INVESTMENT_VEHICLE_TITLE,
  FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMNS,
  FUND_INVESTMENTS_SUMMARY_SPREADSHEET_INVESTMENT_VEHICLE_ALIAS,
  FUND_INVESTMENTS_SUMMARY_SPREADSHEET_NAME,
  FUND_INVESTMENTS_SUMMARY_SPREADSHEET_TITLE_ALIAS,
  FUND_INVESTMENTS_SUMMARY_SPREADSHEET_TOTAL_ALIAS,
  FUND_INVESTMENTS_TOTAL_TITLE,
} from 'pages/FundInvestments/common/constants';
import { formatDateViewLL } from 'utilities';
import { CreateRowsParams } from './createRows.types';
import { createFundRows } from './utils';

const { as_of_date: AS_OF_DATE } = FUND_INVESTMENTS_SUMMARY_SPREADSHEET_COLUMNS;

const createRows = (params: CreateRowsParams): Rows => {
  const { forceReadOnly, fundInvestmentDetails, fundOptions, measurementDate } = params;

  return [
    {
      alias: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_TITLE_ALIAS,
      className: `${FUND_INVESTMENTS_SUMMARY_SPREADSHEET_NAME}__title division-bottom-only`,
      gridType: 'string',
      largeHeader: true,
      readOnly: true,
      value: `${AS_OF_DATE.title} ${formatDateViewLL(measurementDate)}`,
    } as Row,
    {
      alias: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_INVESTMENT_VEHICLE_ALIAS,
      className: `${FUND_INVESTMENTS_SUMMARY_SPREADSHEET_NAME}__investment-vehicle subheader-division`,
      gridType: 'string',
      readOnly: true,
      value: <ValueWithLinkViewer isDarkMode name={FUND_INVESTMENTS_INVESTMENT_VEHICLE_TITLE} />,
    } as Row,
    ...createFundRows({ forceReadOnly, fundInvestmentDetails, fundOptions }),
    {
      alias: FUND_INVESTMENTS_SUMMARY_SPREADSHEET_TOTAL_ALIAS,
      className: `${FUND_INVESTMENTS_SUMMARY_SPREADSHEET_NAME}__total division`,
      format: null,
      gridType: 'string',
      readOnly: true,
      value: FUND_INVESTMENTS_TOTAL_TITLE,
    } as Row,
  ];
};

export default createRows;
